import el from "@cypherpotato/el";
import { Icon } from "../../components/icon";
import { ExternalLink } from "../../components/link";
import { Main } from "../../components/layout";

export function LoginLayout(panel) {
    return Main(
        { classList: ["login-page"], "data-auth-mode": "login" },
        el("section.login-access-panel",
            el("div.login-access-shell",
                el("img.login-logo", {
                    src: "/assets/aivax-alt.png",
                    alt: "AIVAX"
                }),
                panel,
                el("footer.login-support-row",
                    el("span", Icon("shield-keyhole-line"), "Secure authentication")
                )
            )
        ),
        el("section.login-hero",
            el("img.login-hero-image.login.is-active", {
                src: "/assets/auth_login_0.webp",
                alt: "",
                style: { opacity: "1", transform: "scale(1)" }
            }),
            el("nav.login-hero-nav",
                ExternalLink("Documentation", "https://docs.aivax.net/docs/overview"),
                ExternalLink("Platform", "https://aivax.net/")
            ),
            el("div.login-hero-copy.login.is-active",
                { style: { opacity: "1", transform: "none" } },
                el("h2", "Orchestrate intelligence. Unify everything."),
                el("p", "A single layer for inference, RAG, agents and tools.")
            )
        )
    );
}
